/* Gentle Beauty — "AI visibility" product gallery.
   Stage crossfade, thumbnails, mobile swipe with progress/counter, AI scan + hotspots, hover lens (lazy 2000px),
   variant media switching/filtering and a lazily-built fullscreen lightbox with pinch / double-tap zoom. No dependencies. */
(function () {
  'use strict';
  if (window.GBGallery) return;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var mqDesktop = window.matchMedia('(min-width: 750px)');
  var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var raf = window.requestAnimationFrame.bind(window);

  function Gallery(root) {
    this.root = root;
    this.track = $('[data-gb-track]', root);
    this.slides = $$('[data-gb-slide]', root);
    this.thumbs = $$('[data-gb-thumb]', root);
    this.layout = root.dataset.layout;
    this.index = Number(root.dataset.start) || 0;
    this.scanEnabled = root.dataset.scan === 'true';
    this.statusEl = $('[data-gb-scan-status]', root);
    this.statusText = $('[data-gb-scan-text]', root);
    this.scanTimer = null;
    this.bind();
    this.updateMeta();
    this.initScanObserver();
    root.__gbGallery = this;
    root.setAttribute('data-gb-init', '');
    if (!this.isStage()) this.scrollToIndex(this.index, false);
  }

  Gallery.prototype.visible = function () {
    return this.slides.filter(function (s) { return !s.classList.contains('is-filtered'); });
  };
  Gallery.prototype.isStage = function () { return mqDesktop.matches && this.layout !== 'grid'; };
  Gallery.prototype.isCarousel = function () { return !mqDesktop.matches; };

  Gallery.prototype.bind = function () {
    var self = this, root = this.root;

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gb-thumb]');
      if (thumb) { e.preventDefault(); return self.go(self.visible().indexOf(self.slides[Number(thumb.dataset.index)])); }
      if (e.target.closest('[data-gb-gallery-prev]')) return self.step(-1);
      if (e.target.closest('[data-gb-gallery-next]')) return self.step(1);
      var play = e.target.closest('[data-gb-media-play]');
      if (play) return self.loadDeferred(play.closest('[data-gb-deferred-media]'), true);
      var dot = e.target.closest('.gb-hotspot__dot');
      if (dot) { e.preventDefault(); return self.toggleHotspot(dot.closest('[data-gb-hotspot]')); }
      var open = e.target.closest('[data-gb-open-lightbox]');
      if (open && root.dataset.lightbox === 'true') {
        e.preventDefault();
        var slide = open.closest('[data-gb-slide]');
        var vis = self.visible();
        var idx = slide ? vis.indexOf(slide) : self.index;
        if (!slide && self.isCarousel()) idx = self.carouselIndex();
        return self.openLightbox(Math.max(0, idx), open);
      }
    });

    if (this.track) {
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
      });
      var ticking = false, settle = null;
      this.track.addEventListener('scroll', function () {
        if (!self.isCarousel()) return;
        if (!ticking) { ticking = true; raf(function () { ticking = false; self.onCarouselScroll(); }); }
        clearTimeout(settle);
        settle = setTimeout(function () { self.runScan(self.visible()[self.index]); }, 180);
      }, { passive: true });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('[data-gb-hotspot].is-open', root).forEach(function (h) { self.toggleHotspot(h, false); });
    });

    // Variant media events from assets/gb-product.js
    var productRoot = root.closest('[data-gb-product]');
    if (productRoot) {
      productRoot.addEventListener('gb:variant:media', function (e) { self.showVariantMedia(e.detail.mediaId, e.detail.product); });
    }

    // Hover lens (desktop, fine pointer)
    if (root.dataset.zoom === 'lens') {
      root.addEventListener('pointerover', function (e) {
        if (e.pointerType !== 'mouse' || !mqHover.matches) return;
        var frame = e.target.closest('[data-gb-frame]');
        if (frame && !frame.__lens) self.initLens(frame);
      });
    }

    var onResize = function () { self.updateMeta(); if (!self.isStage()) self.scrollToIndex(self.index, false); };
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', onResize); else mqDesktop.addListener(onResize);
  };

  Gallery.prototype.step = function (dir) {
    var vis = this.visible();
    if (!vis.length) return;
    var base = this.isCarousel() ? this.carouselIndex() : this.index;
    this.go((base + dir + vis.length) % vis.length);
  };

  Gallery.prototype.go = function (i, opts) {
    opts = opts || {};
    var vis = this.visible();
    if (i < 0 || i >= vis.length) return;
    var prev = vis[this.index], next = vis[i];
    var changed = prev !== next;
    this.index = i;

    if (this.isStage()) {
      if (changed) {
        this.slides.forEach(function (s) { s.classList.remove('is-leaving'); });
        if (prev) { prev.classList.remove('is-active'); prev.classList.add('is-leaving'); setTimeout(function () { prev.classList.remove('is-leaving'); }, 520); }
        next.classList.add('is-active');
        this.pauseMedia(prev);
        this.maybeAutoplay(next);
        this.runScan(next);
      }
    } else if (this.isCarousel()) {
      this.scrollToIndex(i, !opts.instant);
    } else {
      // desktop grid
      this.slides.forEach(function (s) { s.classList.toggle('is-active', s === next); });
      if (opts.scroll) {
        var top = next.getBoundingClientRect().top + window.pageYOffset - 120;
        if (Math.abs(next.getBoundingClientRect().top) > window.innerHeight * 0.4) window.scrollTo({ top: top, behavior: mqReduce.matches ? 'auto' : 'smooth' });
        this.runScan(next);
      }
    }
    this.updateMeta();
  };

  Gallery.prototype.scrollToIndex = function (i, smooth) {
    var vis = this.visible(), slide = vis[i];
    if (!slide || !this.track) return;
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: smooth && !mqReduce.matches ? 'smooth' : 'auto' });
  };

  Gallery.prototype.carouselIndex = function () {
    var vis = this.visible(), left = this.track.scrollLeft, best = 0, bestDist = Infinity, base = this.track.offsetLeft;
    vis.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - base - left); if (d < bestDist) { bestDist = d; best = i; } });
    return best;
  };

  Gallery.prototype.onCarouselScroll = function () {
    var i = this.carouselIndex();
    if (i !== this.index) {
      var vis = this.visible();
      this.pauseMedia(vis[this.index]);
      vis.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      this.index = i;
      this.updateMeta();
    }
  };

  Gallery.prototype.updateMeta = function () {
    var vis = this.visible(), total = vis.length, i = this.index, active = vis[i];
    $$('[data-gb-counter-current]', this.root).forEach(function (el) { el.textContent = Math.min(i + 1, total); });
    $$('[data-gb-counter-total]', this.root).forEach(function (el) { el.textContent = total; });
    var bar = $('[data-gb-progress]', this.root);
    if (bar) bar.style.setProperty('--gb-progress', (total ? ((i + 1) / total) * 100 : 100) + '%');
    var activeIndex = active ? Number(active.dataset.index) : -1;
    var thumbsWrap = $('[data-gb-thumbs]', this.root);
    this.thumbs.forEach(function (t) {
      var on = Number(t.dataset.index) === activeIndex;
      t.classList.toggle('is-active', on);
      if (on) {
        t.setAttribute('aria-current', 'true');
        if (thumbsWrap) {
          var vertical = thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 2;
          if (vertical) {
            var top = t.offsetTop - thumbsWrap.clientHeight / 2 + t.clientHeight / 2;
            thumbsWrap.scrollTo({ top: top, behavior: 'smooth' });
          } else if (thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 2) {
            thumbsWrap.scrollTo({ left: t.offsetLeft - thumbsWrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          }
        }
      } else t.removeAttribute('aria-current');
    });
    this.root.classList.toggle('is-first', i === 0);
    this.root.classList.toggle('is-last', i >= total - 1);
  };

  /* ---------- Variant media ---------- */
  Gallery.prototype.showVariantMedia = function (mediaId, product) {
    var self = this;
    if (this.root.dataset.variantFilter === 'true' && product && product.variants) {
      var starts = {};
      product.variants.forEach(function (v) { if (v.media) starts[v.media] = true; });
      var group = null, groups = {};
      this.slides.forEach(function (s) {
        var id = Number(s.dataset.mediaId);
        if (starts[id]) group = id;
        groups[id] = group; // null = shared media before the first variant image
      });
      var target = Number(mediaId);
      if (starts[target]) {
        this.slides.forEach(function (s) {
          var g = groups[Number(s.dataset.mediaId)];
          var show = g === null || g === target;
          s.classList.toggle('is-filtered', !show);
          if (!show) s.classList.remove('is-active', 'is-leaving');
        });
        this.thumbs.forEach(function (t) {
          var g = groups[Number(t.dataset.mediaId)];
          t.hidden = !(g === null || g === target);
        });
      }
    }
    var vis = this.visible();
    var idx = -1;
    vis.forEach(function (s, i) { if (Number(s.dataset.mediaId) === Number(mediaId)) idx = i; });
    if (idx < 0) return;
    if (this.isStage() && vis.indexOf(this.slides.filter(function (s) { return s.classList.contains('is-active'); })[0]) < 0) {
      this.index = -1;
    }
    this.go(idx, { scroll: true });
    if (this.lightbox && this.lightbox.gallery === this) this.lightbox.rebuild(this);
  };

  /* ---------- Deferred video / external video ---------- */
  Gallery.prototype.loadDeferred = function (wrap, play) {
    if (!wrap || wrap.hasAttribute('data-loaded')) return;
    var tpl = $('template', wrap);
    if (!tpl) return;
    var node = tpl.content.firstElementChild ? tpl.content.firstElementChild.cloneNode(true) : null;
    if (!node) return;
    wrap.setAttribute('data-loaded', '');
    wrap.appendChild(node);
    if (node.tagName === 'VIDEO') {
      node.setAttribute('playsinline', '');
      if (wrap.hasAttribute('data-autoplay') && !play) { node.muted = true; }
      var p = node.play(); p && p.catch(function () { node.muted = true; node.play().catch(function () {}); });
    }
  };
  Gallery.prototype.maybeAutoplay = function (slide) {
    var wrap = slide && $('[data-gb-deferred-media][data-autoplay]', slide);
    if (wrap) {
      if (wrap.hasAttribute('data-loaded')) { var v = $('video', wrap); v && v.play().catch(function () {}); }
      else this.loadDeferred(wrap, false);
    }
  };
  Gallery.prototype.pauseMedia = function (slide) {
    if (!slide) return;
    $$('video', slide).forEach(function (v) { try { v.pause(); } catch (e) {} });
    $$('iframe', slide).forEach(function (f) {
      try {
        f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        f.contentWindow.postMessage('{"method":"pause"}', '*');
      } catch (e) {}
    });
  };

  /* ---------- AI scan + hotspots ---------- */
  Gallery.prototype.initScanObserver = function () {
    var self = this;
    var first = this.visible()[this.index];
    if (!('IntersectionObserver' in window)) { this.slides.forEach(function (s) { s.classList.add('is-detected'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var slide = en.target;
        io.unobserve(slide);
        if (self.isStage() && slide !== self.visible()[self.index]) return;
        if (!self.isStage() && self.isCarousel() && slide !== self.visible()[self.index]) return;
        var img = $('img', slide);
        var start = function () { self.runScan(slide); };
        if (img && !img.complete) img.addEventListener('load', start, { once: true }); else setTimeout(start, 250);
      });
    }, { threshold: 0.45 });
    if (this.layout === 'grid' && mqDesktop.matches) this.slides.forEach(function (s) { io.observe(s); });
    else if (first) io.observe(first);
  };

  Gallery.prototype.runScan = function (slide) {
    if (!slide) return;
    var hotspots = $$('[data-gb-hotspot]', slide);
    var self = this;
    if (!this.scanEnabled || mqReduce.matches || slide.dataset.type !== 'image') {
      slide.classList.add('is-detected');
      return;
    }
    if (slide.__scanning) return;
    slide.__scanning = true;
    slide.classList.remove('is-detected', 'is-scanning');
    void slide.offsetWidth;
    slide.classList.add('is-scanning');
    this.setStatus(this.root.dataset.scanLabel, 'scanning');
    clearTimeout(this.scanTimer);
    this.scanTimer = setTimeout(function () {
      slide.classList.remove('is-scanning');
      slide.classList.add('is-detected');
      slide.__scanning = false;
      if (hotspots.length) {
        self.setStatus((self.root.dataset.scanDone || '').replace('[count]', hotspots.length), 'done');
        clearTimeout(self.statusHide);
        self.statusHide = setTimeout(function () { self.setStatus('', 'hidden'); }, 3200);
      } else {
        self.setStatus('', 'hidden');
      }
    }, 1350);
  };

  Gallery.prototype.setStatus = function (text, state) {
    if (!this.statusEl) return;
    this.statusEl.setAttribute('data-state', state);
    if (text && this.statusText) this.statusText.textContent = text;
  };

  Gallery.prototype.toggleHotspot = function (hotspot, force) {
    if (!hotspot) return;
    var open = typeof force === 'boolean' ? force : !hotspot.classList.contains('is-open');
    if (open) $$('[data-gb-hotspot].is-open', this.root).forEach(function (h) { if (h !== hotspot) { h.classList.remove('is-open'); var d = $('.gb-hotspot__dot', h); d && d.setAttribute('aria-expanded', 'false'); } });
    hotspot.classList.toggle('is-open', open);
    var dot = $('.gb-hotspot__dot', hotspot);
    if (dot) dot.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  /* ---------- Hover lens ---------- */
  Gallery.prototype.initLens = function (frame) {
    var slide = frame.closest('[data-gb-slide]');
    var src = slide && slide.dataset.zoomSrc;
    var img = $('img.gb-gallery__img', frame);
    if (!src || !img) return;
    frame.__lens = true;
    var scale = Number(this.root.dataset.zoomScale) || 2.5;
    var lens = document.createElement('span');
    lens.className = 'gb-lens';
    lens.setAttribute('aria-hidden', 'true');
    frame.appendChild(lens);
    var hi = new Image();
    hi.decoding = 'async';
    hi.onload = function () { lens.style.backgroundImage = 'url("' + src + '")'; lens.classList.add('is-ready'); };
    hi.src = src;

    var pending = null, fit = getComputedStyle(img).objectFit;
    var contentRect = function () {
      var r = img.getBoundingClientRect();
      var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
      var ir = nw / nh, rr = r.width / r.height, w = r.width, h = r.height, x = r.left, y = r.top;
      if (fit === 'contain') {
        if (ir > rr) { h = r.width / ir; y = r.top + (r.height - h) / 2; } else { w = r.height * ir; x = r.left + (r.width - w) / 2; }
      } else if (fit === 'cover') {
        if (ir > rr) { w = r.height * ir; x = r.left - (w - r.width) / 2; } else { h = r.width / ir; y = r.top - (h - r.height) / 2; }
      }
      return { x: x, y: y, w: w, h: h, frame: frame.getBoundingClientRect() };
    };
    var move = function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.target.closest('.gb-hotspot, .gb-gallery__overlay, .gb-gallery__zoom-chip, .gb-gallery__insights, .gb-gallery__arrow')) { frame.classList.remove('is-zooming'); return; }
      pending = { cx: e.clientX, cy: e.clientY };
      raf(function () {
        if (!pending) return;
        var c = contentRect(), fr = c.frame, size = lens.offsetWidth || 180;
        var px = (pending.cx - c.x) / c.w, py = (pending.cy - c.y) / c.h;
        if (px < 0 || px > 1 || py < 0 || py > 1) { frame.classList.remove('is-zooming'); pending = null; return; }
        frame.classList.add('is-zooming');
        var bw = c.w * scale, bh = c.h * scale;
        lens.style.transform = 'translate3d(' + (pending.cx - fr.left - size / 2) + 'px,' + (pending.cy - fr.top - size / 2) + 'px,0)';
        lens.style.backgroundSize = bw + 'px ' + bh + 'px';
        lens.style.backgroundPosition = -(px * bw - size / 2) + 'px ' + -(py * bh - size / 2) + 'px';
        pending = null;
      });
    };
    frame.addEventListener('pointermove', move, { passive: true });
    frame.addEventListener('pointerleave', function () { frame.classList.remove('is-zooming'); });
  };

  /* ---------- Lightbox ---------- */
  Gallery.prototype.openLightbox = function (visibleIndex, trigger) {
    var items = this.visible().filter(function (s) { return s.dataset.type === 'image' && s.dataset.zoomSrc; });
    if (!items.length) return;
    var target = this.visible()[visibleIndex];
    var start = Math.max(0, items.indexOf(target));
    if (!Lightbox.instance) Lightbox.instance = new Lightbox();
    this.lightbox = Lightbox.instance;
    this.lightbox.open(this, items, start, trigger);
  };

  function Lightbox() {
    var el = document.createElement('div');
    el.className = 'gb-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.hidden = true;
    el.innerHTML =
      '<div class="gb-lightbox__bar">' +
      '<span class="gb-lightbox__counter" aria-live="polite"></span>' +
      '<span class="gb-lightbox__hint"></span>' +
      '<button type="button" class="gb-lightbox__btn gb-lightbox__close" data-lb-close><svg class="gb-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '</div>' +
      '<div class="gb-lightbox__track" data-lb-track></div>' +
      '<button type="button" class="gb-lightbox__btn gb-lightbox__nav gb-lightbox__nav--prev" data-lb-prev><svg class="gb-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 6-6 6 6 6"/></svg></button>' +
      '<button type="button" class="gb-lightbox__btn gb-lightbox__nav gb-lightbox__nav--next" data-lb-next><svg class="gb-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg></button>' +
      '<div class="gb-lightbox__thumbs" data-lb-thumbs></div>';
    document.body.appendChild(el);
    this.el = el;
    this.track = $('[data-lb-track]', el);
    this.thumbsWrap = $('[data-lb-thumbs]', el);
    this.counter = $('.gb-lightbox__counter', el);
    this.hint = $('.gb-lightbox__hint', el);
    this.index = 0;
    this.bind();
  }

  Lightbox.prototype.bind = function () {
    var self = this, el = this.el;
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-close]')) return self.close();
      if (e.target.closest('[data-lb-prev]')) return self.go(self.index - 1);
      if (e.target.closest('[data-lb-next]')) return self.go(self.index + 1);
      var th = e.target.closest('[data-lb-thumb]');
      if (th) return self.go(Number(th.dataset.index));
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); return self.close(); }
      if (e.key === 'ArrowRight') return self.go(self.index + 1);
      if (e.key === 'ArrowLeft') return self.go(self.index - 1);
      if (e.key === 'Tab') {
        var f = $$('button:not([hidden])', el).filter(function (b) { return b.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    var ticking = false, settle;
    this.track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        raf(function () {
          ticking = false;
          var i = Math.round(self.track.scrollLeft / Math.max(1, self.track.clientWidth));
          if (i !== self.index) { self.resetZoom(self.index); self.index = i; self.updateMeta(); }
        });
      }
      clearTimeout(settle);
    }, { passive: true });
  };

  Lightbox.prototype.open = function (gallery, items, start, trigger) {
    this.gallery = gallery;
    this.trigger = trigger;
    var root = gallery.root;
    this.el.setAttribute('aria-label', root.dataset.labelViewer || '');
    $('[data-lb-close]', this.el).setAttribute('aria-label', root.dataset.labelClose || 'Close');
    $('[data-lb-prev]', this.el).setAttribute('aria-label', root.dataset.labelPrev || 'Previous');
    $('[data-lb-next]', this.el).setAttribute('aria-label', root.dataset.labelNext || 'Next');
    this.hint.textContent = root.dataset.lightboxHint || '';
    this.build(items);
    this.el.hidden = false;
    document.body.classList.add('gb-lock');
    var self = this;
    raf(function () {
      self.el.classList.add('is-open');
      self.go(start, true);
      $('[data-lb-close]', self.el).focus({ preventScroll: true });
    });
  };

  Lightbox.prototype.rebuild = function (gallery) {
    if (this.el.hidden) return;
    var items = gallery.visible().filter(function (s) { return s.dataset.type === 'image' && s.dataset.zoomSrc; });
    this.build(items);
    this.go(0, true);
  };

  Lightbox.prototype.build = function (items) {
    var self = this;
    this.items = items;
    this.states = items.map(function () { return { s: 1, x: 0, y: 0 }; });
    this.track.innerHTML = '';
    this.thumbsWrap.innerHTML = '';
    items.forEach(function (slide, i) {
      var fig = document.createElement('figure');
      fig.className = 'gb-lightbox__slide';
      var zoom = document.createElement('div');
      zoom.className = 'gb-lightbox__zoom';
      var img = document.createElement('img');
      img.alt = slide.dataset.alt || '';
      img.decoding = 'async';
      img.draggable = false;
      img.loading = Math.abs(i - self.index) <= 1 ? 'eager' : 'lazy';
      img.src = slide.dataset.zoomSrc;
      zoom.appendChild(img);
      fig.appendChild(zoom);
      self.track.appendChild(fig);
      self.bindZoom(zoom, img, i);

      var th = document.createElement('button');
      th.type = 'button';
      th.className = 'gb-lightbox__thumb';
      th.setAttribute('data-lb-thumb', '');
      th.dataset.index = i;
      th.setAttribute('aria-label', (i + 1) + ' / ' + items.length);
      var ti = document.createElement('img');
      ti.src = slide.dataset.thumbSrc || slide.dataset.zoomSrc;
      ti.alt = '';
      ti.loading = 'lazy';
      th.appendChild(ti);
      self.thumbsWrap.appendChild(th);
    });
    this.el.classList.toggle('is-single', items.length < 2);
  };

  Lightbox.prototype.go = function (i, instant) {
    var n = this.items.length;
    if (!n) return;
    i = (i + n) % n;
    this.resetZoom(this.index);
    this.index = i;
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant || mqReduce.matches ? 'auto' : 'smooth' });
    this.updateMeta();
  };

  Lightbox.prototype.updateMeta = function () {
    var n = this.items.length, i = this.index;
    this.counter.textContent = (i + 1) + ' / ' + n;
    var wrap = this.thumbsWrap;
    $$('[data-lb-thumb]', wrap).forEach(function (t, j) {
      var on = j === i;
      t.classList.toggle('is-active', on);
      if (on) { t.setAttribute('aria-current', 'true'); wrap.scrollTo({ left: t.offsetLeft - wrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
      else t.removeAttribute('aria-current');
    });
  };

  Lightbox.prototype.apply = function (i) {
    var st = this.states[i], zoom = this.track.children[i];
    if (!zoom) return;
    var z = zoom.firstElementChild, img = z.firstElementChild;
    img.style.transform = 'translate3d(' + st.x + 'px,' + st.y + 'px,0) scale(' + st.s + ')';
    z.classList.toggle('is-zoomed', st.s > 1.01);
    this.track.classList.toggle('is-locked', st.s > 1.01);
  };

  Lightbox.prototype.resetZoom = function (i) {
    if (!this.states || !this.states[i]) return;
    this.states[i] = { s: 1, x: 0, y: 0 };
    this.apply(i);
  };

  Lightbox.prototype.clamp = function (i, zoomEl) {
    var st = this.states[i], r = zoomEl.getBoundingClientRect();
    var maxX = (r.width * (st.s - 1)) / 2, maxY = (r.height * (st.s - 1)) / 2;
    st.x = Math.max(-maxX, Math.min(maxX, st.x));
    st.y = Math.max(-maxY, Math.min(maxY, st.y));
  };

  Lightbox.prototype.zoomAt = function (i, zoomEl, scale, cx, cy) {
    var st = this.states[i], r = zoomEl.getBoundingClientRect();
    var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
    var ns = Math.max(1, Math.min(4, scale));
    var k = ns / st.s;
    st.x = ox - (ox - st.x) * k;
    st.y = oy - (oy - st.y) * k;
    st.s = ns;
    if (ns <= 1.01) { st.s = 1; st.x = 0; st.y = 0; }
    this.clamp(i, zoomEl);
    this.apply(i);
  };

  Lightbox.prototype.bindZoom = function (zoomEl, img, i) {
    var self = this, pointers = {}, startDist = 0, startScale = 1, lastTap = 0, last = null;
    var dist = function () {
      var p = Object.keys(pointers).map(function (k) { return pointers[k]; });
      return p.length < 2 ? 0 : Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
    };
    var center = function () {
      var p = Object.keys(pointers).map(function (k) { return pointers[k]; });
      return { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2 };
    };
    zoomEl.addEventListener('pointerdown', function (e) {
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var count = Object.keys(pointers).length;
      if (count === 2) { startDist = dist(); startScale = self.states[i].s; }
      if (count === 1) last = { x: e.clientX, y: e.clientY };
      if (self.states[i].s > 1 || count === 2) { try { zoomEl.setPointerCapture(e.pointerId); } catch (err) {} }
    });
    zoomEl.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var count = Object.keys(pointers).length, st = self.states[i];
      if (count === 2 && startDist) {
        var c = center();
        self.zoomAt(i, zoomEl, (startScale * dist()) / startDist, c.x, c.y);
      } else if (count === 1 && st.s > 1 && last) {
        st.x += e.clientX - last.x;
        st.y += e.clientY - last.y;
        last = { x: e.clientX, y: e.clientY };
        self.clamp(i, zoomEl);
        self.apply(i);
      }
    });
    var end = function (e) {
      delete pointers[e.pointerId];
      if (Object.keys(pointers).length < 2) startDist = 0;
      if (e.type === 'pointerup' && e.pointerType !== 'mouse') {
        var now = Date.now();
        if (now - lastTap < 280) { self.toggleZoom(i, zoomEl, e.clientX, e.clientY); lastTap = 0; }
        else lastTap = now;
      }
      last = null;
    };
    zoomEl.addEventListener('pointerup', end);
    zoomEl.addEventListener('pointercancel', end);
    zoomEl.addEventListener('dblclick', function (e) { e.preventDefault(); self.toggleZoom(i, zoomEl, e.clientX, e.clientY); });
    zoomEl.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && self.states[i].s <= 1) return;
      e.preventDefault();
      self.zoomAt(i, zoomEl, self.states[i].s * (e.deltaY < 0 ? 1.12 : 0.89), e.clientX, e.clientY);
    }, { passive: false });
  };

  Lightbox.prototype.toggleZoom = function (i, zoomEl, x, y) {
    this.zoomAt(i, zoomEl, this.states[i].s > 1.01 ? 1 : 2.5, x, y);
  };

  Lightbox.prototype.close = function () {
    var self = this;
    this.el.classList.remove('is-open');
    document.body.classList.remove('gb-lock');
    setTimeout(function () { self.el.hidden = true; self.track.innerHTML = ''; self.thumbsWrap.innerHTML = ''; }, 320);
    if (this.gallery && this.items[this.index]) {
      var vis = this.gallery.visible(), idx = vis.indexOf(this.items[this.index]);
      if (idx > -1 && idx !== this.gallery.index) this.gallery.go(idx, { instant: true });
    }
    if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
  };

  /* ------------------------------------------------------------------ */
  window.GBGallery = {
    Gallery: Gallery,
    init: function (scope) {
      $$('[data-gb-gallery]:not([data-gb-init])', scope || document).forEach(function (root) {
        try { new Gallery(root); } catch (e) { if (window.console) console.error(e); }
      });
    }
  };
  var boot = function () { window.GBGallery.init(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { window.GBGallery.init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var hs = e.target.closest && e.target.closest('[data-gb-hotspot]');
    if (!hs) return;
    var slide = hs.closest('[data-gb-slide]'), root = hs.closest('[data-gb-gallery]');
    if (root && root.__gbGallery && slide) {
      var g = root.__gbGallery, idx = g.visible().indexOf(slide);
      if (idx > -1) g.go(idx);
      slide.classList.add('is-detected');
      g.toggleHotspot(hs, true);
    }
  });
})();
